exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media print {\nbody * {\n    visibility: hidden;\n    height: auto;\n}\n#printDiv,\n  #printDiv * {\n    visibility: visible;\n}\n#printDiv {\n    left: 0px;\n    top: 0px;\n    position: absolute;\n}\n@page {\n    size: 330mm 500mm;\n    margin: 14mm;\n}\n}\n", ""]);

// exports
